module.exports = __webpack_public_path__ + "static/media/pricingWitness.8d437f51.webp";